import { Assessment } from './assessment';
import { AssessmentRecordUserStatus } from './enums';
import { EntityTypes } from './enums/entityTypes';

export interface AssessmentRecord {
  assessmentRecordId: string;
  entityType: EntityTypes.assessmentRecord;
  assessmentId: string;
  orgId: string;
  createdByUserId: string;
  createdByUserName: string;
  userOpen?: boolean;
  users?: AssessmentRecordUserHolder;
  completed: boolean;
  created: number;
  lastUpdated: number;
  assessmentReport?: string;
  assessmentDescription?: string;
  assessmentName?: string;
  assessmentToken?: string;
  assessmentDuration?: string;
  assessmentSections?: string[];
}

export interface AssessmentRecordUserHolder {
  [userId: string]: AssessmentRecordUser;
}

export interface AssessmentRecordUser {
  userId: string;
  userName: string;
  name: string;
  status: AssessmentRecordUserStatus;
  completed: boolean;
  completedDate?: number;
}

export interface CreateAssessmentRecordProps {
  assessmentId: string;
  users: AssessmentRecordUserProps[];
}

export interface AssessmentRecordUserProps {
  userId: string;
  userName: string;
}

export interface UpdateAssessmentRecordProps {
  assessmentRecordId: string;
  completed?: boolean;
}
